<template>
  <div class="bg-gray">
    <div class="swiper">
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide v-for="item in banner" :key="item.id">
          <img :src="item.logo" alt="" @click="jumpBtn(item)">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <transition name="fade">
    <div class="" v-if="statistics">
      <div class="web-wepper">
        <div class="information-web">
          <span class="tit">房车预定数据快报</span>
          <div class="">
            总成交<span>{{statistics.finish_num}}</span>辆
          </div>
          <div class="">
            关注支持<span>{{statistics.follow}}</span><i v-show="statistics.follow > 10000">万</i>
          </div>
          <div class="none">
            参与车型<span>{{statistics.product_num}}</span>种
          </div>
          <div class="time none">
            数据截止于<br>
            {{filDate(time)}}
          </div>
        </div>

        <div class="hot-web-rv flex-none">
          <h3> <span>火热预定</span><a @click="goList('0')">查看更多</a></h3>
          <div class="hot-web-max">
            <div @click="openProductDetail(item)" class="product-item col-xs-3" v-for="(item, index) in products" :key="index" v-show="index < 3">
              <div class="banner">
                <img :src="item.logo + '?x-oss-process=style/mfill-3x2'" alt="">
                <span class="reserve">{{item.tag}}</span>
                <p class="bottom">
                  <span class="time">上市时间:{{filDate(item.publish_at)}}</span>
                  <span class="num">已抢先预定<i>{{item.sold_num}}</i>辆</span>
                </p>
              </div>
              <div class="title">
                {{item.title}}
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>

        <div class="hot-web-rv flex-none" v-if="special && special.length > 0">
          <h3 class="special"><span>特价秒杀</span><a @click="goList('1')">查看更多</a></h3>
          <div class="hot-web-max">
            <div @click="openProductDetail(item)" class="product-item col-xs-3" v-for="(item, index) in special" :key="index" v-show="index < 3">
              <div class="banner">
                <img :src="item.logo + '?x-oss-process=style/mfill-3x2'" alt="">
                <span class="reserve">{{item.tag}}</span>
                <p class="bottom">
                  <span class="price">特价:<b>{{filPrice(item.special_price)}}</b><i v-show="item.special_price > 10000">万</i></span>
                  <span class="num">仅剩<i>{{item.stock_surplus}}</i>辆</span>
                </p>
              </div>
              <div class="title">
                {{item.title}}
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
  </transition>
  </div>
</template>

<script>
import HomeService from '../service/HomeService'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import filterTime from '../tools/date/format.js'

// let vm = null
export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data: () => ({
    banner: null,
    products: null,
    special: null,
    statistics: null,
    swiperOption: {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      speed: 2000,
      loop: false,
      resistanceRatio: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    },
    time: new Date()
  }),
  methods: {
    init () {
      this.getList()
    },
    async getList () {
      // todo loading
      const res = await HomeService.getHomeSetting()
      if (res) {
        const { pcbanner, products, special, statistics } = res
        this.banner = pcbanner
        this.products = products
        this.special = special
        this.statistics = statistics
      }
    },
    openProductDetail (item = {}) {
      const { id } = item
      this.$router.push({ name: 'ProductDetail', params: { id } })
    },
    filSwiper (list) {
      const arr = []
      if (list) {
        list.forEach(item => {
          arr.push({ img: item.logo, url: item.link })
        })
      }
      return arr
    },
    filPrice (val) {
      if (val > 10000) {
        return (val / 10000).toFixed(2)
      } else {
        return val
      }
    },
    goList (ind) {
      this.$router.push({ name: 'ProductList', query: { type: ind } })
    },
    filDate (val) {
      if (val) {
        const date = filterTime(val, 'YYYY-MM-DD').split('-')
        return date[0] + '年' + date[1] + '月' + date[2] + '日'
      }
    },
    jumpBtn (data) {
      window.open(data.link)
    }
  },
  created () {
    // vm = this
    this.init()
  }
}
</script>
